import React from 'react'
import {connect} from "react-redux";
import DataAction from "../../../stores/api/DataAction";

const mapStateToProps = (state, ownProps) => ({
    ...state
});

class Step3 extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            form: {
                firstName: null,
                insertion: null,
                lastName: null,
                phoneNumber: null,
                email: null,
                city: null,
                check: false,
            },
            validation: {
                firstName: false,
                lastName: false,
                phoneNumber: false,
                email: false,
                city: false,
                check: false,
            }
        }
    }

    handleInputChange = (event) => {

        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;

        this.setState({
            form: {
                ...this.state.form,
                [name]: value
            }
        });
    }

    handleOnSubmit = (event) => {
        event.preventDefault()

        this.setState({
            validation: {
                firstName: !this.state.form.firstName,
                lastName: !this.state.form.lastName,
                phoneNumber: !this.state.form.phoneNumber,
                email: !this.state.form.email,
                city: !this.state.form.city,
                check: !this.state.form.check
            }
        })

        const appointmentData = {
            selectedDayName: this.props.data.selectedDayName,
            selectedDayNum: this.props.data.selectedDayNum,
            selectedMonth: this.props.data.selectedMonth,
            selectedOptions: this.props.data.selectedOptions,
            selectedRemark: this.props.data.selectedRemark,
            selectedTime: this.props.data.selectedTime,
            selectedYear: this.props.data.selectedYear,
            form: this.state.form,
        }

        if (this.state.form.firstName && this.state.form.lastName && this.state.form.phoneNumber && this.state.form.email && this.state.form.city && this.state.form.check) {
            this.props.dispatch(DataAction.submitHandler(appointmentData))
        }

    }

    render() {

        let checkboxText = ''
        if (this.props.data.form.algemene_voorwaarden_link && this.props.data.form.privacyverklaring_link) {
            checkboxText = '<span>Ik ga akkoord met de  <a href="' + this.props.data.form.algemene_voorwaarden_link + '" target="_blank">algemene voorwaarden</a> en <a href="' + this.props.data.form.privacyverklaring_link + '">privacyverklaring</a> van Zoon Badkamers & Tegels</span>'
        } else if (this.props.data.form.algemene_voorwaarden_link && !this.props.data.form.privacyverklaring_link) {
            checkboxText = '<span>Ik ga akkoord met de  <a href="' + this.props.data.form.algemene_voorwaarden_link + '" target="_blank">algemene voorwaarden</a> van Zoon Badkamers & Tegels</span>'
        } else if (!this.props.data.form.algemene_voorwaarden_link && this.props.data.form.privacyverklaring_link) {
            checkboxText = '<span>Ik ga akkoord met de  <a href="' + this.props.data.form.privacyverklaring_link + '" target="_blank">privacyverklaring</a> van Zoon Badkamers & Tegels</span>'
        }

        return (

            <div>
                <header className="c-appointment__header">
                    {this.props.data.form.titel &&
                    <h1>{this.props.data.dateTime.titel}</h1>
                    }
                    {this.props.data.form.tekst &&
                    <p>{this.props.data.dateTime.tekst}</p>
                    }
                </header>
                <div className="c-appointment__content-2">
                    <form id='appointment-form' className="c-appointment__form c-form" onSubmit={this.handleOnSubmit}>
                        <div className="c-form__row c-form__row--name">
                            <div className="c-form__group">
                                <label htmlFor="">Voornaam</label>
                                <input type="text" name="firstName" value={this.state.form.firstName}
                                       onChange={this.handleInputChange} onClick={this.handleInputChange}/>
                                {this.state.validation.firstName &&
                                <p className={"form-error-message"}>Vul dit veld in...</p>
                                }
                            </div>
                            <div className="c-form__group">
                                <label htmlFor="">Tussenv.</label>
                                <input type="text" name="insertion" value={this.state.form.insertion}
                                       onChange={this.handleInputChange} onClick={this.handleInputChange}/>
                            </div>
                            <div className="c-form__group">
                                <label htmlFor="">Achternaam</label>
                                <input type="text" name="lastName" value={this.state.form.lastName}
                                       onChange={this.handleInputChange} onClick={this.handleInputChange}/>
                                {this.state.validation.lastName &&
                                <p className={"form-error-message"}>Vul dit veld in...</p>
                                }
                            </div>
                        </div>
                        <div className="c-form__row c-form__row--half">
                            <div className="c-form__group">
                                <label htmlFor="">Telefoonnr.</label>
                                <input type="tel" name="phoneNumber" value={this.state.form.phoneNumber}
                                       onChange={this.handleInputChange} onClick={this.handleInputChange}/>
                                {this.state.validation.phoneNumber &&
                                <p className={"form-error-message"}>Vul dit veld in...</p>
                                }
                            </div>
                            <div className="c-form__group">
                                <label htmlFor="">E-mailadres</label>
                                <input type="email" name="email" value={this.state.form.email}
                                       onChange={this.handleInputChange} onClick={this.handleInputChange}/>
                                {this.state.validation.email &&
                                <p className={"form-error-message"}>Vul dit veld in...</p>
                                }
                            </div>
                        </div>
                        <div className="c-form__row">
                            <div className="c-form__group">
                                <label htmlFor="">Woonplaats</label>
                                <input type="text" name="city" value={this.state.form.city}
                                       onChange={this.handleInputChange} onClick={this.handleInputChange}/>
                                {this.state.validation.city &&
                                <p className={"form-error-message"}>Vul dit veld in...</p>
                                }
                            </div>
                        </div>
                        <div className="c-form__row c-form__row--radio">
                            <div className="c-form__group">
                                <label htmlFor="">
                                    <input type="checkbox" name="check" checked={this.state.form.check}
                                           onChange={this.handleInputChange} onClick={this.handleInputChange}/>
                                    <span dangerouslySetInnerHTML={{__html: checkboxText}}/>
                                </label>
                                {this.state.validation.check &&
                                <p className={"form-error-message"}>U dient akkoord te gaan door de checkbox aan te vinken</p>
                                }
                            </div>
                        </div>
                    </form>
                </div>
                <footer className="c-appointment__footer">
                    <button className="btn btn--rounded btn--beige-dark" form='appointment-form' type="submit"><span>Afspraak bevestigen</span>
                    </button>
                </footer>
            </div>

        )

    }

}

export default connect(mapStateToProps)(Step3);
